<template>
  <el-dialog
    title="新增"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      
      :label-width="formLabelWidth"
      id="form"
    >
      <el-form-item label="开始时间" prop="startTime">
        <el-col :span="18">
          <el-date-picker
            v-model.trim="form.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-col :span="18">
          <el-date-picker
            v-model.trim="form.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="消息内容" prop="message">
        <el-col :span="18">
          <el-input type="textarea" clearable v-model.trim="form.message"></el-input>
        </el-col>
      </el-form-item>
     
      <el-form-item label="排序" prop="sequence">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.sequence"></el-input>
        </el-col>
      </el-form-item>
   
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { publishMessageCud } from "@/api/url";
export default {
  name: "mini-program-message-release-add",
  data() {
    return {
      dialogFormVisible: true,
      form: {
        startTime: "",
        endTime: "",
        message: "",
        sequence: "",    
      },
      formLabelWidth: "120px",
      imgUrl:''
    };
  },
  methods: {
    closeDialog(type) {
      this.$emit("closeDialog", type);
    },
    addrOrEditTrue() {
      this.$postRequest(`${publishMessageCud()}`, {
        ...this.form,
      }).then((res) => {
        if (res.status == 200) {
          this.$message({
            type: "success",
            message: '新增成功',
          });
          this.closeDialog("edit");
        } else {
          this.$message({
            type: "error",
            message: '新增失败',
          });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.form.picture =res?.data??'';
      this.imgUrl= URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return  isLt2M;
    },

  },
};
</script>
<style scoped>
</style>